import { Component, Input, EventEmitter, Output } from '@angular/core';

import {SlideshowService} from '../slideshow.service';
import {ImagesService} from '../../shared/images.service';
import { GettyService } from '../../getty/getty.service';
import { MatDialog } from '@angular/material/dialog';
import { MediaDialog } from './media-dialog';
import { Utils } from '../../utils';

@Component({
    selector: 'image-list',
    templateUrl: 'image-list.html'
})
export class ImageListComponent {

    private _dialog = false;
    private _disableDrop = false;
    @Input()
    set dialog(dialog) {
        this._dialog = dialog;
    }
    get dialog() {
        return this._dialog;
    }
    @Input()
    set disableDrop(disableDrop) {
        this._disableDrop = disableDrop;
    }
    get disableDrop() {
        return this._disableDrop;
    }

    @Output() imageClick = new EventEmitter();
    
    constructor(
        public imagesService: ImagesService,
        public slideshow: SlideshowService,
        private gettyService: GettyService,
        private compDialog: MatDialog,
        public utils: Utils
    ) {}
    drop(e) {
        if( this.slideshow.locked ) {
            return;
        }
        if( e.event.dataTransfer.files.length === 0 ) {
            const text = e.data;
            if( text ) {
                try {
                    const img = JSON.parse(text);
                    if( typeof img === 'object' ) {
                        //TODO: add a todal count of image that are being downloaded from getty
                        this.gettyService.download(img, this.slideshow.assignment.id);
                    }
                } catch(error) {
                    alert('could not read file');
                    throw error;
                }
            }
        } else {
            this.imagesService.handleDropFiles(e.event.dataTransfer.files, this.slideshow.assignment, false);
        }
    }
    clickImage(e, img) {
        if( e.target.classList.contains('mat-icon') ) {
            return;
        }
        this.imageClick.emit(img);
    }
    openMediaDialog() {
        this.compDialog.open(MediaDialog, {
            panelClass: 'media-dialog',
            data: {
                canEdit: !this.slideshow.locked,
                removeEditTab: this.slideshow.currentTabIndex === 3
            }
        })
    }
}